import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Icon from '@/icons'

class Popup extends Component {
  render() {
    const { children, width, onClose } = this.props

    return (
      <div className="fixed absolute--fill w-100 h-100 z-max">
        <div className="absolute absolute--fill bg-black-40" onClick={onClose} />
          <div
            className="absolute centered bg-white br4 pa4 popup-shadow mw-100 maxh-100 overflow-auto"
            style={{ width }}
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute top-0 right-0 bw0 pa2 w2 h2 pointer hover-red outline-0"
            >
              <Icon icon="cross" size="70%" className="db center" />
            </button>

            {children}
          </div>
      </div>
    )
  }
}

Popup.propTypes = {
  children: PropTypes.node,
  width: PropTypes.string,
  onClose: PropTypes.func
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/popup/popup.js